export default __webpack_public_path__ + "static/media/left-arrow.63d60ba3.svg";